import { createFileRoute } from '@tanstack/react-router';

import { PrivacyPolicyPage } from '@/components/legal/PrivacyPolicyPage';
import { DEFAULT_LOCALE } from '~/utils/i18n';

const PrivacyPolicy = () => {
  return <PrivacyPolicyPage />;
};

export const Route = createFileRoute('/privacy')({
  beforeLoad: ({ context }) => ({
    ...context,
    locale: DEFAULT_LOCALE,
  }),
  component: PrivacyPolicy,
});

